import { type CaseReducer } from '@reduxjs/toolkit';

import { emptyState } from '../initialStates';
import { type SessionState } from '../types';

const clearSessionCase: CaseReducer<SessionState> = () => {
  return emptyState;
};

export { clearSessionCase };
